import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models
// ============================================================

export interface FM004 {
  fm004_01: string;        // 庫存產生代號 (PK, max 2 chars)
  fm004_11: string;        // 庫存產生原因說明
  fm004_21: string;        // 建檔人員代號
  fm004_22: string | null; // 建檔日期
  fm004_23: string;        // 建檔時間
  fm004_91: string;        // 修改人員代號
  fm004_92: string | null; // 修改日期
  fm004_93: string;        // 修改時間
}

export interface CreateRequest {
  fm004_01: string;
  fm004_11: string;
}

export interface UpdateRequest {
  fm004_11: string;
}

export interface ListResponse {
  data: FM004[];
  total: number;
  page: number;
  size: number;
}

export interface ValidationError {
  field: string;
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const invReasonApi = {
  async list(page = 1, size = 100, keyword?: string): Promise<ListResponse> {
    const params: Record<string, string | number> = { page, size };
    if (keyword) params.keyword = keyword;
    const res = await apiClient.get('/api/inv-reason', { params });
    return res.data;
  },

  async get(code: string): Promise<FM004> {
    const res = await apiClient.get(`/api/inv-reason/${encodeURIComponent(code)}`);
    return res.data;
  },

  async create(data: CreateRequest): Promise<FM004> {
    const res = await apiClient.post('/api/inv-reason', data);
    return res.data;
  },

  async update(code: string, data: UpdateRequest): Promise<FM004> {
    const res = await apiClient.put(`/api/inv-reason/${encodeURIComponent(code)}`, data);
    return res.data;
  },

  async delete(code: string): Promise<void> {
    await apiClient.delete(`/api/inv-reason/${encodeURIComponent(code)}`);
  },
};
